<template>
  <div class="release-from-load" :class="{ 'release-from-load_disabled': !canEdit }">
    <m-partially-relieve-load
      :active="isShowPartiallyRelieveLoadModal"
      :record="record"
      @close="isShowPartiallyRelieveLoadModal = false"
      @setLoadParams="setLoadParams"
    />
    <m-completely-revieve-load
      :active="isShowCompletelyRelieveLoadModal"
      :record="record"
      @close="isShowCompletelyRelieveLoadModal = false"
    />
    <div class="release-from-load-partially">
      <svg
        v-b-popover.html="{
          container: '#app',
          trigger: 'hover blur',
          content: canEdit ? 'Частично освободить от нагрузки' : 'Расчёт закрыт',
          placement: 'bottom',
        }"
        width="12"
        height="18"
        viewBox="0 0 12 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="canEdit && (isShowPartiallyRelieveLoadModal = true)"
      >
        <path
          d="M8 3H7V4H8V3ZM4 3V4H5V3H4ZM8 14C8.55228 14 9 13.5523 9 13C9 12.4477 8.55228 12 8 12V14ZM4 12C3.44772 12 3 12.4477 3 13C3 13.5523 3.44772 14 4 14V12ZM8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9V11ZM4 9C3.44772 9 3 9.44772 3 10C3 10.5523 3.44772 11 4 11V9ZM2 15.2222V4.77778H0V15.2222H2ZM2 4.77778C2 4.4557 2.33373 4 3 4V2C1.45713 2 0 3.13618 0 4.77778H2ZM9 4C9.66627 4 10 4.4557 10 4.77778H12C12 3.13618 10.5429 2 9 2V4ZM10 4.77778V15.2222H12V4.77778H10ZM10 15.2222C10 15.5443 9.66627 16 9 16V18C10.5429 18 12 16.8638 12 15.2222H10ZM9 16H3V18H9V16ZM3 16C2.33373 16 2 15.5443 2 15.2222H0C0 16.8638 1.45713 18 3 18V16ZM8 4H9V2H8V4ZM3 4H4V2H3V4ZM5 3V1.66667H3V3H5ZM5 1.66667C5 1.85076 4.85076 2 4.66667 2V0C3.74619 0 3 0.746192 3 1.66667H5ZM4.66667 2H7.33333V0H4.66667V2ZM7.33333 2C7.14924 2 7 1.85076 7 1.66667H9C9 0.746193 8.25381 0 7.33333 0V2ZM7 1.66667V3H9V1.66667H7ZM8 12H4V14H8V12ZM8 9H4V11H8V9Z"
          fill="#8E9CBB"
        />
      </svg>
    </div>
    <div class="release-from-load-wholly">
      <svg
        v-b-popover.html="{
          container: '#app',
          trigger: 'hover blur',
          content: canEdit ? 'Полностью освободить от нагрузки' : 'Расчёт закрыт',
          placement: 'bottom',
        }"
        width="12"
        height="18"
        viewBox="0 0 12 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="canEdit && (isShowCompletelyRelieveLoadModal = true)"
      >
        <path
          d="M8 3H7V4H8V3ZM4 3V4H5V3H4ZM2 15.2222V4.77778H0V15.2222H2ZM2 4.77778C2 4.4557 2.33373 4 3 4V2C1.45713 2 0 3.13618 0 4.77778H2ZM9 4C9.66627 4 10 4.4557 10 4.77778H12C12 3.13618 10.5429 2 9 2V4ZM10 4.77778V15.2222H12V4.77778H10ZM10 15.2222C10 15.5443 9.66627 16 9 16V18C10.5429 18 12 16.8638 12 15.2222H10ZM9 16H3V18H9V16ZM3 16C2.33373 16 2 15.5443 2 15.2222H0C0 16.8638 1.45713 18 3 18V16ZM8 4H9V2H8V4ZM3 4H4V2H3V4ZM5 3V1.66667H3V3H5ZM5 1.66667C5 1.85076 4.85076 2 4.66667 2V0C3.74619 0 3 0.746192 3 1.66667H5ZM4.66667 2H7.33333V0H4.66667V2ZM7.33333 2C7.14924 2 7 1.85076 7 1.66667H9C9 0.746193 8.25381 0 7.33333 0V2ZM7 1.66667V3H9V1.66667H7Z"
          fill="#8E9CBB"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import ModalPartiallyRelieveLoad from "@/pages/calculations/create/additions/modal-production-partially-relieve-load";
import ModalCompletelyRelieveLoad from "@/pages/calculations/create/additions/modal-production-completely-relieve-load";

export default {
  name: "production-cell-release-from-load",
  components: {
    "m-partially-relieve-load": ModalPartiallyRelieveLoad,
    "m-completely-revieve-load": ModalCompletelyRelieveLoad,
  },
  props: ["record", "canEdit"],
  data() {
    return {
      isShowPartiallyRelieveLoadModal: false,
      isShowCompletelyRelieveLoadModal: false,
    };
  },
  methods: {
    setLoadParams(params) {
      this.record.salary.value = params.salary;
      this.record.ratio_standart.value = params.standartRatio;
      this.record.bonus_rate.value = params.bonusRate;
      this.record.deprivation_coefficient.value = params.depreciationCoefficient;
    },
  },
};
</script>

<style lang="scss" scoped>
.release-from-load {
  min-width: 90px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  &-partially {
    cursor: pointer;
    margin: 0 10px;
    & svg {
      cursor: pointer;
      outline: none;
    }
  }

  &-wholly {
    margin: 0 10px;
    & svg {
      cursor: pointer;
      outline: none;
    }
  }

  &_disabled {
    cursor: default;

    .release-from-load-partially svg,
    .release-from-load-wholly svg {
      cursor: default;
    }
  }
}
</style>
